import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleRemoveComment(
  state: State,
  comment: Boundaries["removeComment"]["success"],
): State {
  return state.map((result) => ({
    ...result,
    discussions: result.discussions.map((discussion) => {
      const comments = discussion.comments.filter(
        ({ uuid }) => uuid !== comment.uuid,
      );

      return comments.length === discussion.comments.length
        ? discussion
        : {
            ...discussion,
            comments,
            commentsCount: Math.max(
              0,
              (discussion.commentsCount ?? discussion.comments.length) - 1,
            ),
          };
    }),
  }));
}

export { handleRemoveComment };
